enum MfaRequestContexts {
  ASSET_OWNER_AUTH = 'asset_owner_auth',
  ASSET_DEVICE_AUTH = 'asset_device_auth',
  ADMIN_REQUEST_ACCESS = 'admin_request_access',
}

export default MfaRequestContexts